// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/not-at-all.svg';

export const NotAtAll = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
